import { useEffect, useState } from 'react'

import debounce from 'lodash/debounce'

export const useDebouncedSearch = () => {
  const [text, setText] = useState('')
  const [search, setSearch] = useState('')

  useEffect(() => {
    const apply = debounce(() => setSearch(text.trim()), 500)
    apply()
    return () => apply.cancel()
  }, [text])

  const clear = () => {
    setText('')
    setSearch('')
  }

  return { text, setText, search, clear }
}
